<template>
	<v-dialog v-model="showDialog" :max-width="600" persistent>
		<v-card>
			<v-card-text class="text-center">
				Your Iris admin requires that these fields be unique:
				{{ fields.join(', ') }} . Please review the data and re-save
				your form. If this error persists, contact your administrator.
			</v-card-text>
			<v-divider />
			<v-card-actions style="justify-content: center">
				<v-btn color="primary" @click="onConfirm"> Confirm </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

${fields.join( // ", " // )}
<script>
export default {
	name: 'ConfirmModalDialog',
	props: {
		showDialog: Boolean,
		fields: Array,
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onConfirm() {
			this.$emit('confirm');
		},
	},
};
</script>
